<template>
  <v-app>
    <NavigationBar />
    <router-view :style="isServices ? 'margin-top:6em' : 'margin-top:3em'"/>
  </v-app>
</template>

<script>
import NavigationBar from "./views/NavigationBar.vue";
import {mapGetters} from "vuex";

export default {
  name: "App",
  components: {
    NavigationBar,
  },
  data() {
    return {
      loadernavplus: require("@/assets/img/load100new.gif"),
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Some Default Title';
      }
    },
  },
  computed: {
    ...mapGetters([
      "loading_map",
    ]),
    isServices() {
      return this.$route.name == "navigator+";
    },
  }
};
</script>

<style>
@import "@/assets/css/main.css";

.v-text-field.v-text-field--solo .v-input__control {
  min-height: 20px;
  padding: 0;
}
</style>
